import './ToggleSwitch.css';

export default function ToggleSwitch({ ariaLabel, checked, onChange, disabled = false }) {
  return (
    <label className="switch">
      <input
        type="checkbox"
        aria-label={ariaLabel}
        checked={checked}
        disabled={disabled}
        onChange={e => onChange?.(e.target.checked)}
      />
      <span className="slider"></span>
    </label>
  );
}
